module.exports = __webpack_public_path__ + "img/FP2.1a114a52.png";